<kendo-dialog
   *ngIf="isAppointmentOpen$ | async"
   (close)="cancel()"
   [minWidth]="250"
   [width]="'80%'"
   [maxWidth]="'fit-content'"
   [height]="'fit-content'"
   [maxHeight]="'90%'"
>
   <kendo-dialog-titlebar>
      <span class="sam-margin">
         <fa-icon class="sam-margin-right" [icon]="(purpose$ | async)?.titlebarIcon"> </fa-icon>
         {{ dialogTitle$ | async }}</span
      >
   </kendo-dialog-titlebar>
   <samweb-appointment-schedule
      [doShowExchangeAppointmentSubjects$]="doShowExchangeAppointmentSubjects$"
      [appointments$]="selectedAppointments$"
      [currentView$]="currentView$"
      [showBusinessHours$]="showBusinessHours$"
      (viewIndexChange)="onViewIndexChange($event)"
   ></samweb-appointment-schedule>
</kendo-dialog>
